import "./index.scss";
import $ from "jquery";
import "./foundation";
import objectFitImages from 'object-fit-images';
import 'selectric';

$(document).foundation();

const SELECTS = $('.newsletter-signup__form select');
$(document).ready(function () {
  SELECTS.selectric({
    onInit: function () {
      const PARENT_FORM = $(this).parents('form');
      PARENT_FORM.addClass('form--unhidden');
    },
  });
});

// Init Object Fit Polyfill
objectFitImages();

initSocialMediaGrids();

function initSocialMediaGrids() {
  
  const SOCIAL_MEDIA_GRIDS = $(".social-media-grid");
  SOCIAL_MEDIA_GRIDS.each((index, grid) => {
    const GRID = $(grid);
    initInstaFeed(GRID);
  });
}

function initInstaFeed(GRID) {
  
  const INSTAGRAM_FEED = GRID.find("#instagram-feed");
  const IMAGES_WRAPPER = INSTAGRAM_FEED.find("#sb_instagram");


  // IMAGES_WRAPPER.on('DOMNodeRemoved', function(e) {
  //   console.log(e.target, ' was removed');    
  // });
  setTimeout(() => {
    instaFeedDoneLoading(GRID, INSTAGRAM_FEED, IMAGES_WRAPPER);
  }, 1000);
}

function instaFeedDoneLoading(GRID, INSTAGRAM_FEED, IMAGES_WRAPPER) {
  const IMAGES = IMAGES_WRAPPER.find(".sbi_item");
  
  IMAGES.each((index, image) => {
    const IMAGE_WRAPPER = $(image);
    cleanUpImageWrapper(IMAGE_WRAPPER);

    const LINK = IMAGE_WRAPPER.find(".sbi_photo");
    cleanUpLink(LINK);
    LINK.prepend('<div class="social-media-grid__cell-cover"></div>');

    const IMG = LINK.find("img");
    cleanUpImage(IMG);
  });

  setTimeout(() => {
    updateGridMarkup(GRID, INSTAGRAM_FEED, IMAGES);
  }, 0);

}

function updateGridMarkup(GRID, INSTAGRAM_FEED, IMAGES) {
  INSTAGRAM_FEED.html(IMAGES);
  IMAGES.unwrap();
  wrapCells(GRID);
  setTimeout(() => {
    GRID.addClass("is-loaded");
    // Re-call object fit images
    objectFitImages();
  }, 500);
}

function wrapCells(GRID) {
  const CELLS = GRID.find(".social-media-grid__cell");
  const COLUMN_MARKUP = '<div class="social-media-grid__column"></div>';
  CELLS.slice(0, 6).wrapAll(COLUMN_MARKUP);
  CELLS.slice(6, 9).wrapAll(COLUMN_MARKUP);
  CELLS.slice(9, 12).wrapAll(COLUMN_MARKUP);
}

function cleanUpImageWrapper(imageWrapper) {
  imageWrapper.removeAttr("id data-date class");
  imageWrapper.addClass("social-media-grid__cell");
  const TRANSITION_DURATION_OPTIONS = [
    "transition-300ms",
    "transition-500ms",
    "transition-600ms",
    "transition-700ms"
  ];
  imageWrapper.addClass(generateRandomItem(TRANSITION_DURATION_OPTIONS));
}

function cleanUpLink(link) {
  // Delete any icon included with the post
  // For carousel and video posts
  const PARENT = link.parent();
  const ICON = PARENT.find('svg');
  ICON.remove();

  // Clean up the link markup
  link.unwrap();
  link.removeAttr("style class");
  link.addClass("social-media-grid__cell--instagram");
}

function cleanUpImage(image) {
  image.removeAttr("style width height");
}

function generateRandomItem(array) {
  return array[Math.floor(Math.random() * array.length)];
}



// WEBPACK FOOTER //
// ./src/index.js